import { render, staticRenderFns } from "./signature.vue?vue&type=template&id=f7071ca4&scoped=true"
import script from "./signature.vue?vue&type=script&lang=js"
export * from "./signature.vue?vue&type=script&lang=js"
import style0 from "./signature.vue?vue&type=style&index=0&id=f7071ca4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7071ca4",
  null
  
)

export default component.exports